import React, { useEffect } from 'react'
import { ConstructorMeta } from 'client/fragments/listerFragment/components/ConstructorMeta/ConstructorMeta'
import ProductsContainer from 'client/fragments/listerFragment/components/ProductsContainer/ProductsContainer'
import { processWithGtm } from 'client/fragments/listerFragment/store/middleware/gtm'

export const ListerComponent = props => {
  useEffect(() => {
    const onBackPressed = () => window.location.reload()
    window.addEventListener('popstate', onBackPressed)
    return () => window.removeEventListener('popstate', onBackPressed)
  }, [])

  useEffect(() => {
    processWithGtm({ data: props })
  }, []) // eslint-disable-line

  return (
    <>
      <ConstructorMeta />
      <ProductsContainer />
    </>
  )
}
